import { render, staticRenderFns } from "./GAcademicPromotion.vue?vue&type=template&id=a1c3ffb0&scoped=true&"
import script from "./GAcademicPromotion.vue?vue&type=script&lang=ts&"
export * from "./GAcademicPromotion.vue?vue&type=script&lang=ts&"
import style0 from "./GAcademicPromotion.vue?vue&type=style&index=0&id=a1c3ffb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c3ffb0",
  null
  
)

export default component.exports